import React from "react";
import { Link } from "gatsby";

import { EuiText, EuiCallOut } from "@elastic/eui";

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="alert" title="Home Assistant">
      <EuiText>
        <h2>All ioBroker Tutorials</h2>
        <ul>
          <li>
            <Link to="/Software/Linux/Home_Assistant/">
              Home Assistant installation with Docker (Updated 04.04.2024)
            </Link>
          </li>
          <li>
            <Link to="/Advanced_User/INSTAR_MQTT_Broker/Home_Assistant/">
              INSTAR MQTT Broker with Home Assistant
            </Link>
          </li>
        </ul>

        <h2>All ioBroker FAQs</h2>
        <ul>
          <li>
            <Link to="/Frequently_Asked_Question/UHD_Home_Assistant_MQTT_Discovery/">
              Home Assistant MQTT Auto-Discovery
            </Link>
          </li>
          <li>
            <Link to="/Frequently_Asked_Question/Home_Assistant_INSTAR_WQHD_MQTTv5_Camera_Control/">
              Home Assistant 2022.8.6 Configuration for your WQHD INSTAR MQTTv5
              Broker
            </Link>
          </li>
          <li>
            <Link to="/Frequently_Asked_Question/Home_Assistant_INSTAR_WQHD_Camera_Live_Video/">
              Home Assistant 2022.8.6 and the INSTAR WQHD Live Videostream
            </Link>
          </li>
          <li>
            <Link to="/Frequently_Asked_Question/INSTAR_MQTT_Home_Assistant_Self-Signed_Certificate/">
              INSTAR MQTT Home Assistant Self-Signed Certificate
            </Link>
          </li>
        </ul>
      </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox;
